import { Link } from "react-router-dom";
import { siteData } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50 pt-16 md:pt-20 pb-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <Link to="/" className="inline-block">
            <span className="text-4xl md:text-5xl font-heading font-bold tracking-tight">cssbuy.biz</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <p className="text-background-50/60 text-sm leading-relaxed max-w-xs">
              A maior coleção de CSSBuy Spreadsheet, links organizados, Yupoo e guias completos para compras internacionais.
            </p>
            <div className="flex items-center gap-4 mt-5">
              {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-youtube-fill'].map((icon) => (
                <span
                  key={icon}
                  className="w-8 h-8 rounded-full border border-background-50/20 flex items-center justify-center hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-xs text-background-50/60`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <p className="text-background-50/40 text-xs uppercase tracking-wider font-semibold mb-1 whitespace-nowrap">ENDEREÇO</p>
              <p className="text-background-50/60 text-sm">São Paulo, Brasil</p>
              <p className="text-background-50/60 text-sm">Atendimento online</p>
            </div>
            <div>
              <p className="text-background-50/40 text-xs uppercase tracking-wider font-semibold mb-1 whitespace-nowrap">EMAIL</p>
              <p className="text-background-50/60 text-sm">contato@cssbuy.biz</p>
            </div>
            <div>
              <p className="text-background-50/40 text-xs uppercase tracking-wider font-semibold mb-1 whitespace-nowrap">BLOG</p>
              <Link
                to="/cssbuy-spreadsheet-guia-completo"
                className="text-background-50/60 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Guia Completo CSSBuy Spreadsheet
              </Link>
            </div>
          </div>

          <div>
            <div className="rounded-2xl overflow-hidden h-40 md:h-48">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20product%20photography%20curated%20collection%20of%20sneakers%20and%20accessories%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20style%20neutral%20toned%20background%20clean%20sophisticated%20composition%20modern%20lifestyle%20aesthetic&width=500&height=350&seq=footer-v2-img&orientation=landscape"
                alt="CSSBuy Spreadsheet"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/40 text-xs whitespace-nowrap">
            &copy; {siteData.year} cssbuy.biz — Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/politica-editorial" className="text-background-50/40 text-xs hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              Política Editorial
            </Link>
            <Link to="/disclaimer" className="text-background-50/40 text-xs hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              Disclaimer
            </Link>
            <Link to="/contato" className="text-background-50/40 text-xs hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              Contato
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}